var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('health-report-exam-enter',{ref:"examEnter",attrs:{"title":_vm.title,"format":_vm.format,"disabled":_vm.disabled}})}
var staticRenderFns = []

export { render, staticRenderFns }